module.exports = __webpack_public_path__ + "static/Menu-2a111a4b54e167b0ddad9aa856b721c2.png";